import cx from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import type { LinkProps } from 'react-router-dom';
import styled from 'styled-components';

const StyledCard = styled(Link)`
  background-color: var(--beta) !important;
  border: 2px solid rgba(205, 222, 254, 0.1) !important;
  border-radius: var(--border-radius-sm);

  &.high-priority{
    border: 2px solid rgba(255, 0, 0, 1) !important;
  }
`;

export const Container = ({
  className,
  ...props
}: React.PropsWithChildren<LinkProps>): React.ReactElement => (
  <StyledCard {...props} className={cx('p-16px text-white x-pseudo w-100', className)} />
);
